import React from 'react';

import { IToggleOption } from '@rbilabs/components-library/build/components/toggle';

import { IItem } from '@rbi-ctg/menu';
import { useFeatureMenu } from 'hooks/use-feature-menu';
import useDonation from 'state/order/hooks/use-donation';

import { DonationAtCheckout } from '../donation-at-checkout';

const itemToToggleOption = (item: IItem): IToggleOption => {
  const id = item._id;
  const name = item.name.locale;

  return {
    value: id,
    label: name,
  };
};

const DonationContainer = () => {
  const { featureMenu } = useFeatureMenu();
  const donationItems =
    featureMenu?.donationItemsAtCheckout?.map(item => ({ ...item } as IItem)) || [];
  const { handleAddDonationCartEntry, handleOnEnableDonationChange, selectedDonationCartEntry } =
    useDonation({
      donationItems,
    });

  const donationTermAndConditionUrl = featureMenu?.donationTermAndConditionUrl?.locale || '';

  const donationToggleOptions = donationItems.map(itemToToggleOption);

  const handleDonationToggleChange = (newSelectedDonationId: string) => {
    const optionItem = donationItems.find(item => item?._id === newSelectedDonationId);

    if (!optionItem) {
      return;
    }

    handleAddDonationCartEntry(optionItem);
  };

  if (!donationToggleOptions.length) {
    return null;
  }

  return (
    <DonationAtCheckout
      donationOptions={donationToggleOptions}
      onToggleChange={handleDonationToggleChange}
      onCheckboxChange={handleOnEnableDonationChange}
      selectedDonationId={selectedDonationCartEntry?._id}
      donationLink={donationTermAndConditionUrl}
    />
  );
};

export default DonationContainer;
